import { render, staticRenderFns } from "./my-collection.vue?vue&type=template&id=7269eef0&scoped=true&"
import script from "./my-collection.vue?vue&type=script&lang=js&"
export * from "./my-collection.vue?vue&type=script&lang=js&"
import style0 from "./my-collection.vue?vue&type=style&index=0&id=7269eef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7269eef0",
  null
  
)

export default component.exports